export default __webpack_public_path__ + "static/media/icon-red-close.fcd0c7e8.svg";